import { getAudioContext } from './audioCtx.js';

let muted = false;

export const setMuted = (m: boolean): void => {
  muted = m;
};
export const isMuted = (): boolean => muted;

const playTone = (
  freq: number,
  duration: number,
  type: OscillatorType = 'sine',
  vol = 0.18,
  delay = 0,
): void => {
  if (muted) return;
  const ctx = getAudioContext();
  if (!ctx) return;
  const t0 = ctx.currentTime + delay;
  const osc = ctx.createOscillator();
  osc.type = type;
  osc.frequency.value = freq;
  const gain = ctx.createGain();
  gain.gain.setValueAtTime(0, t0);
  gain.gain.linearRampToValueAtTime(vol, t0 + 0.012);
  gain.gain.exponentialRampToValueAtTime(0.0001, t0 + duration);
  osc.connect(gain).connect(ctx.destination);
  osc.start(t0);
  osc.stop(t0 + duration + 0.05);
};

export const playMove = (): void => {
  playTone(523.25, 0.18, 'triangle', 0.12); // C5
  playTone(659.25, 0.22, 'sine', 0.08, 0.03); // E5
  playTone(783.99, 0.28, 'sine', 0.06, 0.06); // G5
};

/**
 * Soft "flip" click — a short woody knock to accompany each cube
 * physically flipping over. Called once per flood, not once per cell.
 */
export const playFlip = (): void => {
  playTone(440, 0.06, 'square', 0.05);
  playTone(660, 0.08, 'sine', 0.04, 0.02);
};

export const playWin = (): void => {
  // C major arpeggio rising → sustained octave hit. Anticipation + reward.
  const notes = [523.25, 659.25, 783.99, 1046.5, 1318.51, 1567.98, 2093.0];
  notes.forEach((f, i) => playTone(f, 0.4, 'triangle', 0.18, i * 0.07));
  playTone(130.81, 1.1, 'sine', 0.18, 0.5);
  playTone(261.63, 1.1, 'sine', 0.14, 0.5);
  playTone(392, 1.1, 'sine', 0.1, 0.5);
  playTone(2637.02, 0.6, 'sine', 0.08, 0.55);
};

export const playFail = (): void => {
  playTone(220, 0.25, 'sawtooth', 0.1);
  playTone(174.61, 0.4, 'sawtooth', 0.1, 0.18);
};

export const playPenalty = (): void => {
  playTone(98, 0.18, 'square', 0.08);
  playTone(82.41, 0.24, 'square', 0.08, 0.1);
};

export const playPick = (): void => {
  playTone(880, 0.06, 'sine', 0.05);
};
